// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import CareerPageContent from './PageComponent/CareerPageContent';

function Career() {

  useMeta({
    title: 'Careers with Callistus Blinds - Apply for a Job - Discover a New World Of Career Opportunities',
    description: 'Find your next job at Callistus Blinds | At Callistus Blinds, we strive to provide a solid platform for professionals who will be our change agents – catalysts who with their excellence take the organization to Global levels | Apply for a Job Now | Callistus Blinds is an equal opportunity workplace for Professionals | Come Lets Build the career with Leading Manufacturer of Window Blinds',
    canonical: 'https://callistusblinds.com/career/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Careers with Callistus Blinds - Apply for a Job - Discover a New World Of Career Opportunities',
      description:
        'Find your next job at Callistus Blinds | At Callistus Blinds, we strive to provide a solid platform for professionals who will be our change agents – catalysts who with their excellence take the organization to Global levels | Apply for a Job Now | Callistus Blinds is an equal opportunity workplace for Professionals | Come Lets Build the career with Leading Manufacturer of Window Blinds',
      url: 'https://callistusblinds.com/career/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <CareerPageContent />
      <Footer />
    </div>
  );
}

export default Career;
